// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3V6Pe","label":"Radio_label___Mid8","checkMark":"Radio_checkMark__1bAHR","disabled":"Radio_disabled__3o5pX"};